exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drop-container[data-v-797b56b2]{margin-top:-10px;min-height:50px;height:100px;height:calc(100% + 20px)}.item-dopzone[data-v-797b56b2]{margin:auto!important;overflow:visible}.item-container[data-v-797b56b2]{display:none}.item-container.active-drop[data-v-797b56b2]{display:block;min-height:50px!important}.mouseoverexpand .item-container[data-v-797b56b2]{min-height:10px;padding-top:2px;padding-bottom:2px}.expand-border[data-v-797b56b2]{border-left:5px solid #cbcccc!important;margin-left:10px!important;margin-bottom:10px}.card[data-v-797b56b2]{background-color:initial}a[data-v-797b56b2]{color:inherit!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-797b56b2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procedure/procedure-expand.vue
// module id = 1294
// module chunks = 0